import { isDev, reactQueryDevtoolsToggleAtom } from '@capsicum/common';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';

export const CustomReactQueryDevtools = () => {
	const [isDevtoolsVisible] = useAtom(reactQueryDevtoolsToggleAtom);
	const [DevTool, setDevTool] = useState<JSX.Element | null>(null);

	useEffect(() => {
		if (isDev()) {
			(async () => {
				const { ReactQueryDevtools } = await import('@tanstack/react-query-devtools');

				setDevTool(<ReactQueryDevtools />);
			})();
		}
	}, []);

	return isDevtoolsVisible ? DevTool : null;
};
